import ListingContactsCardList from './ListingContactsCardList.component';

export default ListingContactsCardList;